import {
  INVOICE_ACTIVITY_SET_FILTER,
  INVOICE_ACTIVITY_SET_DATA,
  INVOICE_ACTIVITY_UPDATE,
  INVOICE_ACTIVITY_RESET_PAGINATION,
  INVOICE_ACTIVITY_RESET_FILTERS,
  INVOICE_ACTIVITY_SET_PAGINATION,
  INVOICE_ACTIVITY_SET_LOADING,
} from 'src/actions/constants';

const defaultState = {
  shouldUpdate: true,
  loading: false,
  selectedFilters: {},
  pagination: {
    pageNo: 1,
    pageSize: 10,
    isLastPage: false,
  },
};
export default (state : any = defaultState, action) => {
  switch (action.type) {
    case INVOICE_ACTIVITY_SET_FILTER: {
      return {
        ...state,
        selectedFilters: {
          ...state.selectedFilters,
          ...action.data,
          queryString: action.data.queryString || undefined,
        },
        pagination: defaultState.pagination,
        shouldUpdate: true,
        activityData: {
          events: [],
        },
      };
    }
    case INVOICE_ACTIVITY_SET_DATA: {
      return {
        ...state,
        activityData: {
          events: action.data,
        },
      };
    }
    case INVOICE_ACTIVITY_UPDATE: {
      return {
        ...state,
        shouldUpdate: true,
      };
    }
    case INVOICE_ACTIVITY_RESET_PAGINATION: {
      return {
        ...state,
        pagination: defaultState.pagination,
        activityData: {
          events: [],
        },
      };
    }
    case INVOICE_ACTIVITY_SET_PAGINATION: {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          pageNo: action.data?.pageNo || state.pagination.pageNo,
          pageSize: action.data?.pageSize || state.pagination.pageSize,
          isLastPage: action.data?.isLastPage || false,
        },
        shouldUpdate: action.shouldUpdate,
      };
    }
    case INVOICE_ACTIVITY_RESET_FILTERS: {
      return {
        ...state,
        shouldUpdate: true,
        selectedFilters: defaultState.selectedFilters,
        pagination: defaultState.pagination,
        activityData: {
          events: [],
        },
      };
    }
    case INVOICE_ACTIVITY_SET_LOADING: {
      return {
        ...state,
        loading: action.val,
      };
    }
    default : return state;
  }
};
